import { useState, useEffect } from 'react';
import { httpGet, APIEndpoint, EndpointType } from '../utils/apiService'
import { Order, OrdersResponse } from '../models/OrdersResponse'

const apiURL = APIEndpoint(EndpointType.MyOrders);


export const useMyOrders = (customerID: string, refreshKey: number) => {
    const [orders, setMyOrders] = useState<Order[]>([])
    const [ordersError, setOrdersError] = useState("")
    const [loading, setLoading] = useState(false)

    function createSampleOrder(): Order {
        return {
            id: "TSG-20240420-SMPL",
            customerID: "1",
            orderDate: "2024-04-23T18:25:56.179Z",
            description: "Sample Order",
            totalPrice: 123.45,
            fulfillment: {
                id: "TSG-20240420-smpl",
                type: "download",
                createdAt: "2024-04-23T18:25:56.179Z",
                downloadURL: "https://orders-thesharegroup-prod.s3.us-west-2.amazonaws.com/20240420-TSG-20240420-SMPL/order_TSG-20240420-SMPL.zip",
                downloads: []
            },
        }
    }

    useEffect(() => {
        if (!customerID || customerID == "unknown") return;
        setOrdersError("")
        setMyOrders([])

        const url = apiURL + customerID

        setLoading(true)

        const maxQueryCount = 20; // limit the number of queries to prevent infinite loops

        const fetchOrders = async () => {
            let queryCount = 0;
            let allOrders: Order[] = [];
            let nextPage: string | undefined = undefined;
            let currentUrl = url;

            try {
                do {
                    queryCount++;
                    if (queryCount > maxQueryCount) {
                        setOrdersError("Too many queries, stopping to prevent infinite loop");
                        setMyOrders([]);
                        setLoading(false);
                        return;
                    }

                    const data = await httpGet(currentUrl);
                    const myOrdersResponse = data as OrdersResponse;

                    if (myOrdersResponse.status === 'error') {
                        setOrdersError("service error - " + myOrdersResponse.errorMessage);
                        setMyOrders([]);
                        setLoading(false);
                        return;
                    } else {
                        if (myOrdersResponse.orders == undefined) {
                            myOrdersResponse.orders = [createSampleOrder()];
                        }
                        allOrders = allOrders.concat(myOrdersResponse.orders);
                    }

                    if (myOrdersResponse.page && myOrdersResponse.page != "") {
                        nextPage = myOrdersResponse.page;
                        currentUrl = apiURL + customerID + "?page=" + nextPage;
                    } else {
                        nextPage = undefined;
                    }
                } while (nextPage);
                setMyOrders(allOrders);
            } catch (error) {
                setMyOrders([]);
                if (error instanceof Error) {
                    console.log("error contacting service: ", error.message);
                    setOrdersError("client error - " + error.message + " (" + url + ")" + " - " + error.name);
                } else {
                    setOrdersError("No orders were found");
                }
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();

    }, [customerID, refreshKey]);

    return { orders, loading, ordersError };
};

